// Explicit array annotation for DI safety after minification
export const TranslateModuleConfig = [
    '$translateProvider',
    ($translateProvider) => {
        $translateProvider
            .useLoader('AsyncTranslationLoader')
            .registerAvailableLanguageKeys(['en', 'pt', 'es'], {
            'en_*': 'en',
            'en-*': 'en',
            'pt_*': 'pt',
            'pt-*': 'pt',
            'es_*': 'es',
            'es-*': 'es',
        })
            .useSanitizeValueStrategy('sanitizeParameters')
            .fallbackLanguage('en')
            .preferredLanguage('en')
            .determinePreferredLanguage();
        $translateProvider.useCookieStorage();
    },
];
